module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"update_review":"レビュー修正"}}')
  delete Component.options._Ctor
}
